import bootstrap from '../assets/bootstrap.png';
import csharp from '../assets/csharp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import nextjs from '../assets/nextjs.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sanity from '../assets/sanity.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import tailwind from '../assets/tailwind.png';

import random from '../assets/random.jpg';
import profile from '../assets/profile.jpg';
import logo from '../assets/logo.svg';

export default {
  bootstrap,
  csharp,
  css,
  figma,
  git,
  html,
  javascript,
  nextjs,
  node,
  react,
  redux,
  sanity,
  sass,
  tailwind,
  typescript,
  random,
  profile,
  logo
};